var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthereumChain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "#627EEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9951 11.1992L23.8203 11.7827V28.7115L23.9951 28.8829L31.9932 24.2379L23.9951 11.1992Z",
    fill: "#C0CBF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 11.1992L16 24.2379L23.9983 28.8829V20.6661V11.1992Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.997 30.3691L23.8984 30.4871V36.5174L23.997 36.8001L32 25.7266L23.997 30.3691Z",
    fill: "#C0CBF6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9983 36.8001V30.3691L16 25.7266L23.9983 36.8001Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28.8926L31.9981 24.2476L24 20.6758V28.8926Z",
    fill: "#8197EE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24.2476L23.9983 28.8926V20.6758L16 24.2476Z",
    fill: "#C0CBF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumChain);
export default __webpack_public_path__ + "static/media/ethereum-chain.30552f5ea76ba21bf6b40c929a2d92f6.svg";
export { ForwardRef as ReactComponent };